import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Practitioner } from 'src/app/shared/models/practitioner.model';
import { PractitionerService } from 'src/app/shared/services/practitioner.service';
import { ActivatedRoute, Params } from '@angular/router';
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Therapy } from 'src/app/shared/models/therapy.model';
import { ModalNotificationComponent } from 'src/app/shared/components/modal-notification/modal-notification.component';
import { faQuestionCircle  } from '@fortawesome/free-regular-svg-icons';
import { Document } from 'src/app/shared/models/document.model';
import { Observable, of, Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PractitionerEdit } from 'src/app/shared/enums/practitioner-edit.enum';
import { PractitionerStatus } from 'src/app/shared/enums/practitioner-status.enum';
import { StatusBannerComponent } from 'src/app/shared/components/status-banner/status-banner.component';
import { TestimonialValues } from 'src/app/shared/resources/testimonial-values.resource';

@Component({
  selector: 'app-practitioner-detail',
  templateUrl: './practitioner-detail.component.html',
  styleUrls: ['./practitioner-detail.component.scss']
})
export class PractitionerDetailComponent implements OnInit {
  userSubscription: Subscription;
  canEdit: Observable<boolean> = null;
  practitioner: Practitioner;
  backIcon = faChevronLeft;
  selectedTherapies: Array<Therapy> = new Array<Therapy>();
  values = TestimonialValues.getValues();
  questionIcon = faQuestionCircle;
  @ViewChild('confirmation') confirmationModal: ModalNotificationComponent;
  @ViewChild('statusBanner') statusBanner: StatusBannerComponent;
  currentWindowWidth: number;

  get isMobileScreen(): boolean {
    return this.currentWindowWidth <= 770;
  }

  get practitionerEditEnum(): typeof PractitionerEdit {
    return PractitionerEdit;
  }

  get practitionerStatusEnum(): typeof PractitionerStatus {
    return PractitionerStatus;
  }

  constructor(private practitionerService: PractitionerService, private route: ActivatedRoute, private location: Location, private authService: AuthService) { }

  ngOnInit(): void {
    this.currentWindowWidth = window.innerWidth;
    this.route.params.subscribe((params: Params) => {
      this.loadPractitioner(params['id']);
    });
  }

  reloadStatusBanner(id: string) {
    this.loadPractitioner(id);
    if (this.statusBanner) {
      // this.statusBanner.loadPendingUpdates();
    }
  }

  loadPractitioner(id: string) {
    this.practitionerService.getPractitioner(id).subscribe((practitioner: Practitioner) => {
      this.practitioner = practitioner;
      this.userSubscription = this.authService.user.subscribe(user => {
        if (!user) {
          this.canEdit = of(false);
          return;
        }
        this.canEdit = of(user.isAdmin || user.uid === this.practitioner.id);
      });
    }, error => {
      alert(error);
    });
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  goBack(): void {
    this.location.back();
  }

  openConfirmation(): void {
    this.confirmationModal.open('Thank you!', 'Someone will contact you shortly.', 'Okay');
  }

  getProfessionalBodies(documents: Document[]): Document[] {
    return documents.filter((doc: Document) => doc.isProfessionalBody());
  }

  getAccreditedRegisters(documents: Document[]): Document[] {
    return documents.filter((doc: Document) => doc.isAccreditedRegister());
  }

  onTherapySelected(therapy: Therapy): void {
    let index: number = this.selectedTherapies.indexOf(therapy);
    if (index < 0) {
      this.selectedTherapies.push(therapy);
      return;
    }

    this.selectedTherapies.splice(index, 1);
  }

  isTherapySelected(therapy: Therapy): boolean {
    return this.selectedTherapies.indexOf(therapy) >= 0;
  }

  onSharePractitioner() {
    let listener = (e: ClipboardEvent) => {
      let clipboard = e.clipboardData || window['clipboardData'];
      clipboard.setData('text', environment.webUrl + 'practitioner/' + this.practitioner.id);
      e.preventDefault();
      this.confirmationModal.open('Ready to Share', 'Practitioner link copied to clipboard.', 'Okay');
    };
    document.addEventListener('copy', listener, false)
    document.execCommand('copy');
    document.removeEventListener('copy', listener, false);
  }

  @HostListener('window:resize')
  onResize() {
    this.currentWindowWidth = window.innerWidth;
  }
}
